import { Request, BaseReq, BaseRsp } from '@/data/remote/base';
import { postRequest } from "@/network/httpRequest";
import { ErrorInfo } from "@/network/http";
import { getUUID } from '@/utils'
import { getLang } from "@/locale"

export const requestData = <T extends BaseReq, M extends BaseRsp>(actionName: string, reqData: T, callback?: (errorInfo: ErrorInfo, data: M) => void) => {
    postRequest(actionName, createReqData(reqData), callback);
}

const createReqData = <T extends BaseReq>(reqData: T): Request<T> => {
    return {
        origin: {
            appId: process.env.VUE_APP_APP_ID,
            source: 4,
            deviceId: getDeviceId(),
            appVersion: "1.0",
            appVerCode: 1,
            apiVer: "v1.0",
            timestamp: new Date().getTime(),
            msgId: getUUID(),
            lang: getLang(),
            channel: ""
        },
        data:reqData
    }
}

export const getDeviceId = ():string => {
    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      deviceId = getUUID().replace(/-/g, "");
      localStorage.setItem('deviceId', deviceId);
    }
    
    return deviceId;
};